<template>
    <craft-work-space :work-space="workSpace"/>
</template>

<script>
    import CraftWorkSpace from "./CraftWorkSpace";
    export default {
        name: "CuttingCtaftWS",
        data(){
            return {
                workSpace:this.$const.cuttingWorkSpace
            }
        },
        components: {CraftWorkSpace}
    }
</script>

<style scoped>

</style>